import { render, staticRenderFns } from "./Hyundai-Premium-Chargin-Disclosure.vue?vue&type=template&id=5c74e77e&"
import script from "./Hyundai-Premium-Chargin-Disclosure.vue?vue&type=script&lang=js&"
export * from "./Hyundai-Premium-Chargin-Disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports